import { render } from "./Loader.vue?vue&type=template&id=16fe17be&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=16fe17be&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/user.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16fe17be"]])

export default __exports__